export const word_setting = {
  sdm: "兒童近視治療共享決策(SDM)介紹",
  pda: "兒童近視治療共享決策輔助工具(PDA)",
  treatment: "當小孩被診斷為近視時，我應該讓小孩選擇哪一種治療?",
  control: "當我小孩近視了，該配戴哪一種眼鏡?",
};
